import React from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';

const useStyles = makeStyles((theme) => ({
  root: {
    '& > * + *': {
      marginTop: theme.spacing(3),
    },
  },
}));

export default function MultiSelectAutoComplete({onSelect, selectedOptions, activeOptions, isError}) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Autocomplete
        multiple
        id="tags-outlined"
        options={activeOptions}
        getOptionLabel={(option) => option.email}
        filterSelectedOptions
        onChange={onSelect}
        freeSolo
        value={selectedOptions}
        renderInput={(params) => {
          return <TextField {...params} variant="outlined" placeholder="Emails" error={isError} />;
        }}
      />
    </div>
  );
}